// @flow

import React, {useEffect} from 'react'
import { graphql } from 'gatsby'
import { css } from '@emotion/core'
// import styled from '@emotion/styled'
import Layout from '@/layouts'
import { mq } from '@/styles/theme'
import FormLayout from '@/layouts/FormLayout'
import { Title, Copy, Back } from '@/components/Form'
import ContactForm from '@/forms/contact'

const ContactFormColumnStyles = css`
  margin-top: 190px;
  min-height: 100vh;
  display: flex;
  flex-flow: column nowrap;

  ${mq.lessThan('medium')`
    display: none;
  `};
`

const ContactFormMobileOnlyStyles = css`
  display: none;

  ${mq.lessThan('medium')`
    display: block;
  `};
`
const ContactLinkStyles = css`
  text-decoration: underline;
`

function ContactPage({
  data: {
    settings
  },
}: Props) {
  useEffect(() => {
    document.title = 'Arcadia.org | Contact Us'
  }, []);
  return (
      <FormLayout
        logoSrc={settings.data.company_logo.url}
        logoAlt={settings.data.company_logo.alt}>
        <div>
          <Back>← Back</Back>
          <Title>Contact Us</Title>
          <Copy>
            <i>
                <p>
						    	If you’re interested in our senior living and health care options, 
                  please call{' '}
                  <a href="tel:808-533-5416">
                    <b>(808) 533-5416</b>
                  </a>{' '}
                  or email{' '}
                  <a href="mailto:info@arcadia.org" css={ContactLinkStyles}>
                    <b>info@arcadia.org</b>
                  </a>
                </p>
                <p>
                  For career opportunities or other Human Resources related questions, 
                  please contact our HR Department at{' '}
                  <a href="mailto:HR@arcadia.org" css={ContactLinkStyles}>
                    <b>HR@arcadia.org</b>
                  </a> or{' '}
                  <a href="tel:808-533-5470">
                    <b>(808) 533-5470</b>
                  </a>
                </p>
                <div css={ContactFormMobileOnlyStyles}>
                  <ContactForm action="/contact-page-submission" />
                </div>
            </i>
            <p>
              Mailing Address:
              <br />
              Arcadia Family of Companies
              <br />
              1434 Punahou St
              <br />
              Honolulu, HI 96822
            </p>
	  	  <p>
              <strong>YOU MAY NOT POST OR SEND ANY CONFIDENTIAL OR PATIENT HEALTH INFORMATION ON OR THROUGH THE WEBSITE.</strong>
	  	  </p>
          </Copy>
        </div>
        <div css={ContactFormColumnStyles}>
          <ContactForm action="/contact-page-submission" />
        </div>
      </FormLayout>
  )
}

export const query = graphql`
  { 
    settings: prismicGlobalSettings {
      ...LogoSettings
    }
  }
`

export default ContactPage
